export const getXAppVersionHeader = () => process.env.REACT_APP_APP_VERSION as string;
